import React, { useState, useEffect } from 'react'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@react/react-spectrum/Button'
import { success } from '@react/react-spectrum/Toast'

import './LinearProcess.scss'
import _ from 'lodash'

export default function LinearProcess({ configSteps, evtName, profileSteps }) {
  const [activeStep, setActiveStep] = useState(null)
  const [historySteps, setHistorySteps] = useState([])
  const [init, setInit] = useState(true)
  const steps = configSteps?.map((s) => s.step)
  const eventSteps = configSteps?.map((s) => s.eventType)

  useEffect(() => {
    if (steps?.[activeStep] != undefined && !init) {
      window.dispatchEvent(
        new CustomEvent(evtName, {
          detail: {
            eventType: eventSteps[activeStep],
          },
        })
      )
      success('Moving profile to "' + steps[activeStep] || 'complete.' + '" step.', {
        onClose: () => {},
        timeout: 4000,
      })
    }
  }, [activeStep, init])

  useEffect(() => {
    if (profileSteps) {
      //look for the position of the last profileSteps.eventType in configStep
      const last = _.last(profileSteps)?.entity?.eventType
      const idx = _.findIndex(eventSteps, (s) => {
        return s == last
      })
      setActiveStep(idx === -1 ? 0 : idx)

      //@todo look for the previous history steps if any (based on most current step found)
      //steps may not be contiguous as use can back and forth in the process
      setHistorySteps(idx === -1 ? [] : profileSteps.slice(-(idx + 1)))
    }
  }, [profileSteps])

  const handleClick = (e) => {
    setInit(false)
    switch (e.target.name) {
      case 'back':
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
        break
      case 'next':
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
        break
      case 'reset':
        setActiveStep(0)
      default:
    }
  }

  return (
    activeStep != undefined && (
      <div className='linear-process root'>
        <Stepper activeStep={activeStep}>
          {steps?.map((label, index) => {
            const stepProps = {}
            const labelProps = {}
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
        <div>
          {activeStep === steps?.length ? (
            <div>
              <div className='linear-process instructions'>All steps completed</div>
              <Button onClick={handleClick} name='reset' className='button'>
                Reset
              </Button>
            </div>
          ) : (
            <div>
              <div className='linear-process instructions'>
                {configSteps && configSteps[activeStep].description} <br />{' '}
                {historySteps[activeStep]?.entity?.timestamp &&
                  new Date(historySteps[activeStep]?.entity?.timestamp).toLocaleString([], {
                    dateStyle: 'medium',
                    timeStyle: 'short',
                  })}
              </div>
              <div>
                {/*
                <Button disabled={activeStep === 0} onClick={handleClick} name='back' className='linear-process button'>
                  Back
                </Button>
                */}

                <Button variant='primary' onClick={handleClick} name='next' className='linear-process button'>
                  {activeStep === steps?.length - 1 ? 'Finish' : 'Next'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  )
}
